import React, { useEffect, useState } from "react";
import { SellersProps } from "components/types";
import {
  Box,
  MenuItem,
  Select as SelectMUI,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";
import { useSelector } from "react-redux";
import { AppState } from "store/types";

const Select = ({
  getFilterValues,
  title1,
  title2,
}: {
  list?: SellersProps[];
  title1?: string;
  title2?: string;
  getFilterValues: (filters: any[]) => void;
}) => {
  const filters = useSelector((state: AppState) => state.table.columnFilters);
  const columns = useSelector((state: AppState) => state.table.currentColumns);
  const [value, setValue] = useState<string>("");

  const [keyOption, setKey] = useState<string>("");
  const handleChange = (e: SelectChangeEvent<string>) => {
    setKey(e.target.value);
  };

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  useEffect(() => {
    if (keyOption && value) {
      getFilterValues([keyOption, [value]]);
    }
  }, [keyOption, value]);

  useEffect(() => {
    if (filters?.length) {
      if (filters[0] !== "seller_id") {
        setValue(filters[1]);
        setKey(filters[0]);
      }
    }
  }, [filters]);

  return (
    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <span>{title1 ? title1 : "Find"}</span>
        <SelectMUI
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          onChange={handleChange}
          value={keyOption}
          variant="standard"
          label="Column"
          sx={{
            width: "200px",
            marginTop: "10px",
          }}
        >
          {columns &&
            columns.map((item: GridColDef) => (
              <MenuItem
                key={item.field}
                value={item.field}
                sx={{ fontFamily: "Lato", fontSize: "14px", fontWeight: "400" }}
              >
                {item.headerName}
              </MenuItem>
            ))}
        </SelectMUI>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <span>{title2 ? title2 : "Value"}</span>

        <TextField
          variant="standard"
          sx={{
            width: "300px",
            marginTop: "10px",
            fontFamily: "Lato",
            fontSize: "14px",
          }}
          onChange={handleChangeInput}
          value={value}
        />
      </Box>
    </Box>
  );
};

export default Select;
